<template>
	<section class="bg-color-white">
		<div
			class="container-md container-lg display-flex-smo flex-direction-column-reverse-smo pt-900-lg px-900-lg py-600-md pb-200-smo"
		>
			<img v-reveal:fade-up v-lazy="imageUrl" class="image-container" alt="" />
			<div class="pt-400 pt-200-smo pb-400-smo px-100-smo display-flex-lg justify-content-flex-end-lg">
				<div class="col-7-lg">
					<h2 class="heading-1"> Tearing down barriers to the best&nbsp;investments </h2>
					<div class="delta mt-150">
						<p
							>For almost a century, regulatory barriers made it difficult for individuals to invest in
							private markets, giving billion-dollar institutions preferred access. The result has been
							that most investors have been limited to public markets and excluded from private
							investments—ranging from real estate to venture capital. Technology is finally disrupting
							this status&nbsp;quo.<sup>1</sup>
						</p>
						<p>
							Enter: Fundrise, America’s largest direct-to-consumer private markets manager. We built our
							technology platform to bridge the barrier. Software allows us to achieve the scale of
							institutions without the bureaucracy. Combining our technology and investment expertise, we
							are pioneering a new model to build you a better portfolio.
						</p>
						<div class="mt-300 mt-200-smo">
							<p
								class="eta zeta-smo line-height-125 text-color-content-secondary text-decoration-underline"
							>
								<sup>1</sup>&nbsp;<BaseLink :link="mcKinseyLink" class="text-color-content-secondary"
									>McKinsey “US wealth management: A growth agenda for the coming decade”</BaseLink
								>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const mcKinseyLink: Link = {
	href: 'https://www.mckinsey.com/industries/financial-services/our-insights/us-wealth-management-a-growth-agenda-for-the-coming-decade',
	target: '_blank'
};

const imageUrl = computed((): string => {
	if (appStore.isDesktop) {
		return `${import.meta.env.VITE_CLOUDFRONT_DOMAIN}/images/marketing-site/people-graphs-collage.png`;
	} else {
		return `${import.meta.env.VITE_CLOUDFRONT_DOMAIN}/images/marketing-site/people-graphs-collage-vertical.png`;
	}
});
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1200px) {
	.pt-900-lg {
		padding-top: 9rem;
	}

	.px-900-lg {
		padding-left: 9rem;
		padding-right: 9rem;
	}
}

.image-container {
	max-width: 830px;
}
</style>
